import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import SectionLabel from "@/components/site/SectionLabel";
import CardMark from "@/components/site/CardMark";
import Seo from "@/components/site/Seo";
import { PROMISES } from "@/lib/constants";

const TYPES = [
  {
    h: "Training Partners",
    p: "Coaches, speaker-training organizations, and curriculum providers aligned with our standard.",
  },
  {
    h: "Media Partners",
    p: "Local, regional, and digital media collaborators amplifying speaker stories and recap content.",
  },
  {
    h: "Business & Community Partners",
    p: "Chambers, EDCs, business membership groups, and community-of-practice organizations.",
  },
  {
    h: "Nonprofit Alignments",
    p: "Mission-aligned nonprofits supporting communication, leadership, and youth development.",
  },
  {
    h: "Faith-Based Partners",
    p: "Faith communities supporting speakers, audiences, and message-driven leadership.",
  },
];

export default function Partners() {
  return (
    <div>
      <Seo />
      <PageHero
        pageTitle="Partners"
        eyebrowNumber="01"
        eyebrow="Partners & Ecosystem"
        title="Build It"
        highlight="Together."
        tagline="A platform is stronger when the community behind it is loud, intentional, and aligned."
        description="If your organization develops voices, builds community, or amplifies messages worth hearing — we want to talk."
      />

      {/* PARTNERSHIP TYPES */}
      <section className="bg-midnight border-t border-slate-soft">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
          <SectionLabel number="02">Partnership Types</SectionLabel>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
            {TYPES.map((t) => (
              <div key={t.h} className="card-dark p-8">
                <div className="flex items-center gap-3">
                  <CardMark />
                  <h3 className="font-shoulders font-bold uppercase tracking-wider text-2xl text-white">
                    {t.h}
                  </h3>
                </div>
                <div className="gold-line" />
                <p className="font-manrope text-soft-gray mt-4 leading-relaxed">
                  {t.p}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PARTNER PROMISE */}
      <section className="bg-midnight border-t border-slate-soft">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-14 text-center">
          <SectionLabel number="04" align="center">Our Promise</SectionLabel>
          <p className="font-cormorant text-3xl sm:text-4xl text-white leading-snug">
            “{PROMISES.sponsors}”
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-navy border-t border-slate-soft">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 py-14 text-center">
          <h2 className="font-bebas text-white text-4xl sm:text-5xl leading-[0.95]">
            Have An Aligned <span className="gold-text">Organization?</span>
          </h2>
          <p className="font-manrope text-soft-gray mt-6 max-w-2xl mx-auto">
            Use the contact form and choose <em className="text-gold not-italic">Partnership</em>{" "}
            as the inquiry type. We respond personally.
          </p>
          <Link
            to="/contact"
            data-testid="partners-cta-contact"
            className="btn-gold mt-10 inline-flex"
          >
            <MessageCircle size={18} strokeWidth={1.8} />
            Start The Conversation <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
